import { render, staticRenderFns } from "./schoolActiveRank.vue?vue&type=template&id=373f2194&scoped=true"
import script from "./schoolActiveRank.vue?vue&type=script&lang=js"
export * from "./schoolActiveRank.vue?vue&type=script&lang=js"
import style0 from "./schoolActiveRank.vue?vue&type=style&index=0&id=373f2194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f2194",
  null
  
)

export default component.exports